import React, { useEffect, useState } from "react";
import { Typography, makeStyles, Box, useTheme } from "@material-ui/core";
import DataService from "../../../../Service";
import MaterialTable from "material-table";

function ProgrammeRateDetails() {
  const classes = useStyles();
  const [priceSummary, setPriceSummary] = useState([]);
  const [addOnPriceSummary, setAddOnPriceSummary] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [sepecifiedelemetPrice, setSpecifiedelemetPrice] = useState("");
  const [coachingPgmPrice, setCoachingPgmPrice] = useState("");
  const [loading, setLoading] = useState(false);

  let urlElements = window.location.href.split("/");
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID,
    };
    DataService.getDirectData(
      `/invoices/supplier_programme_price_details`,
      params
    )
      .then((response) => {
        setPriceSummary(response.price_summary);
        setAddOnPriceSummary(response.add_ons_price_summary);
        setTotalCount(response.total_pgm_price);
        setSpecifiedelemetPrice(response.specified_element_price);
        setCoachingPgmPrice(response.total_coaching_pgm_price);
        setLoading(false);
      })

      .catch((err) => {});
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const columns = [
    {
      title: "Label",
      field: "label",
    },
    { title: "Rate card type", field: "rate_card_type" },
    { title: "HRs for program", field: "num_of_hours" },
    { title: "Price", field: "price" ,
    render: (rowData) => (
      <div
      >   
        <span style={{textAlign:"left"}} >
          {rowData.price}
        </span>
      </div>
    ),
  },
    // { title: "Margin % (Acuity)", field: "acuity_margin_percent" },
    // { title: "Margin % (Coach)", field: "coach_margin_percent" },
  ];
  const addOnColumns = [
    { title: "Add-on", field: "add_on",render: (rowData) => (
      <div
      >   
        <span style={{textAlign:"left"}} >
         {rowData.label}
        </span>
      </div>
    ), },
    { title: "", field: "empty_space_1" },
    { title: "", field: "empty_space_2" },
    { title: "Price", field: "price", 
   
    render: (rowData) => (
      <div
      >   
        <span style={{textAlign:"left"}} >
          {rowData.price}
        </span>
      </div>
    ),
  },
    // { title: "Margin % (Acuity)", field: "margin_acuity" },
    // { title: "Margin % (Coach)", field: "margin_coach" },
  ];
  const options = {
    headerStyle: {
      textAlign: "left",
      fontSize: 14,
      backgroundColor: "rgba(7, 121, 131, .15)",
    },
    cellStyle: { textAlign: "left", fontSize: 14 },
    actionsColumnIndex: -1,
    toolbar: false,
    search: false,
    sorting: false,
    showTitle: false,
    draggable: false,
    paging: false,
  };
  const theme = useTheme();

  return (
    <div style={{ width: "100%" }}>
      <Typography
        style={{ paddingTop: "15px", fontSize: 18, color: "#EF7000" }}
        className={classes.heading}
      >
        Price summary
      </Typography>
      <MaterialTable
        style={{ width: "100%", boxShadow: "none" }}
        options={options}
        columns={columns}
        data={priceSummary}
      />
      <Box mt="18px" display="flex">
        <Typography
          style={{ width: "70%", textAlign: "right" }}
          className={classes.heading}
        >
          Coaching program price
        </Typography>
        <Typography
          style={{ width: "13.5%", textAlign: "right" }}
          className={classes.heading}
        >
          {coachingPgmPrice}
        </Typography>
      </Box>

      <MaterialTable
        style={{ width: "100%", boxShadow: "none" }}
        options={options}
        columns={addOnColumns}
        data={addOnPriceSummary}
      />
      <Box mt="18px" display="flex">
        <Typography
          style={{ width: "70%", textAlign: "right" }}
          className={classes.heading}
        >
          Specified elements price
        </Typography>
        <Typography
          style={{ width: "13.5%", textAlign: "right" }}
          className={classes.heading}
        >
          {sepecifiedelemetPrice}
        </Typography>
      </Box>

      <Box
        mt="18px"
        width="100%"
        padding="14px 36px"
        boxSizing="border-box"
        bgcolor="rgba(7, 121, 131, .75)"
        borderRadius="5px"
        display="flex"
      >
        <Typography
          style={{
            width: "70%",
            textAlign: "right",
            color: "#fff",
            marginBottom: 0,
          }}
          className={classes.heading}
        >
          Total program price{" "}
        </Typography>
        <Typography
          style={{
            width: "18%",
            textAlign: "right",
            color: "#fff",
            marginBottom: 0,
          }}
          className={classes.heading}
        >
          {totalCount}
        </Typography>
      </Box>
    </div>
  );
}

export default ProgrammeRateDetails;

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: 14,
    lineHeight: "12px",
    color: "#232323",
    marginBottom: 27,
    fontWeight: "bold",
  },
}));
